<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">

                    <v-row dense>
                        <v-col cols="12">
                            <span color="black" class="headline text-xs-center" v-text="`Datos Plan Cobertura Detalle - Producto ${obModal.producto}`"></span>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Nombre Plan" color="textbox" v-model="obModal.nombrePlan"
                                 readonly outlined dense />
                        </v-col>
                        
                        <v-col cols="12" sm="4">
                            <v-text-field label="Tipo Plan" color="textbox" v-model="obModal.tipoPlan"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Selección Cobertura Plan" color="textbox" v-model="obModal.seleccionCoberturaCliente"
                                 readonly outlined dense />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Estado" color="textbox" v-model="obModal.estado"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4"></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="6"></v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Buscar" color="textbox" v-model="obModal.busqueda" dense clearable prepend-inner-icon="search" />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-data-table :search="obModal.busqueda" :headers="listGeneral.cabeceraDetPlanCob"
                                :items="listGeneral.detalleDetPlanCob" class="elevation-3" >

                                <template v-slot:no-results>
                                    Tu búsqueda de "<span v-text="obModal.busqueda"></span>" no arrojó resultados.
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-row dense class="mt-3 mb-3" align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="siguiente">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDatosDetallePlanCoberturaComponent',
        inject:['siguiente','setData'],
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            obModal: {
                type: Object,
                default: {}
            },
            active:{
                type:Boolean,
                default:false
            }
        },
        data: ()=>({
            cabecera:[
                {text:'Cobertura', value:'cobertura',class:'caption text-xs-center active'},
				{text:'Valor', value:'valorCobertura' ,class:'caption text-xs-center' },
				{text:'Rango Inicial', value:'rangoInicial', class:'caption text-xs-center' },
				{text:'Rango Final', value:'rangoFinal' ,class:'caption text-xs-center' },
				{text:'Intervalo', value:'rangoIntervalo',class:'caption text-xs-center' }
            ]
        }),
        created(){
            this.setData('listGeneral.cabeceraDetPlanCob',this.cabecera,false);
            this.onListar('L');
        },
        watch:{
            active(val){
                if(val && _.size(this.listGeneral.detalleDetPlanCob) == 0){
                    this.setData('listGeneral.cabeceraDetPlanCob',this.cabecera,false);
                    this.onListar('L');
                }
            }
        },
        methods:{
            onListar(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var o = _.merge(
                                        {opcion: 'DETALLE'},
                                        _.pick(this.obModal,['idPlanProducto','idProducto','idTipoPlan'])
                                    );

                    this.setData('listGeneral.detalleDetPlanCob',[],false);
                    axios.post(`${BASE_URI}administrador/planCobertura/listar`,o)
                        .then((r) =>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                var l = _.cloneDeep(r.data.data);
                                l = _.map(l,(v)=>{ return _.mapKeys(v,_.rearg(_.camelCase,1)) });
                                this.setData('listGeneral.detalleDetPlanCob',l,false);
                                this.$forceUpdate();
                        })
                        .catch((e) =>{
                                mensajesAlerta(e, error);
                        });
                }
            }
        }
    }
</script>
